import $ from '../core/Dom';
import Dispatch from '../core/Dispatch';

import { DOM_UPDATED, USER_PREFERENCES_UPDATED } from './events';

const def = {
    ecoMode: 'on'
};

let current = {
    ecoMode: 'on'
};

// let lastUpdatedImageQuality = '';

const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce), (update: slow)').matches;

const defaults = () => def;
const getPrefs = () => current;
const shouldAnimate = () => (current.ecoMode !== 'on' && !reduceMotion());
const isEcoMode = () => current.ecoMode !== 'on';


const setPrefs = prefs => {
    current = prefs;

    localStorage.ecoMode = current.ecoMode || 'off';

    handlePrefs();

    Dispatch.emit(USER_PREFERENCES_UPDATED);
};


const handlePrefs = () => {
    if (localStorage.ecoMode === 'on') {
        document.documentElement.classList.add('eco');
    } else {
        document.documentElement.classList.remove('eco');
    }
    
    handleImages();
    
    // if (localStorage.ecoMode !== lastUpdatedImageQuality) {
    // }
};

const handleImages = $target => {
    const $markup = $target !== undefined ? $target : $('body');
    const $images = $markup.find('[data-prefs-image]');

    $images.each(img => {
        const $img = $(img);
        let didChange = false;
        
        if (current.ecoMode === 'on' && ($img.data('prefs-image') === '' || $img.data('prefs-image') === 'high')) {
            $img.removeClass('lazyload', 'lazyloaded', 'lazyautosizes')
                .attr('srcset', null)
                .attr('sizes', null)
                .attr('data-srcset', $img.attr('data-lowres-srcset'))
                .attr('data-prefs-image', 'low');
            
            didChange = true;
        } else if (current.ecoMode !== 'on' && ($img.data('prefs-image') === '' || $img.data('prefs-image') === 'low')) {
            $img.removeClass('lazyload', 'lazyloaded', 'lazyautosizes')
                .attr('srcset', null)
                .attr('sizes', null)
                .attr('data-srcset', $img.attr('data-highres-srcset'))
                .attr('data-prefs-image', 'high');
            
            didChange = true;
        }

        if (didChange && $img.get(0).tagName.toLowerCase() === 'img') {
            $img.addClass('lazyload');
        }
    });

    // lastUpdatedImageQuality = current.lowres;
};

const onDomUpdated = (key, data) => {
    const $markup = data !== undefined && data.$markup !== undefined ? data.$markup : $('body');
    handleImages($markup);
};

const init = () => {
    if (typeof localStorage.ecoMode !== 'undefined') {
        current.ecoMode = localStorage.ecoMode;
    }

    const params = new URLSearchParams(window.location.search);

    if (params.get('ecoMode') !== null) {
        const ecoModeValue = params.get('ecoMode') === '1' ? 'on' : 'off';
        current.ecoMode = ecoModeValue;
        localStorage.ecoMode = ecoModeValue;
        current.ecoModePopupShown = 'yes';
        localStorage.ecoModePopupShown = 'yes';
    }

    handlePrefs();

    Dispatch.on(DOM_UPDATED, onDomUpdated);
};

export default {
    init,
    setPrefs,
    getPrefs,
    shouldAnimate,
    defaults,
    reduceMotion
};
